"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const SidebySideSelector_vue_1 = __importDefault(require("./SidebySideSelector.vue"));
const SidebySideLoader_vue_1 = __importDefault(require("./SidebySideLoader.vue"));
const FarmItem_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Projects/FarmItem.vue"));
const MetricSelectItem_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Metrics/MetricSelectItem.vue"));
const LastVisitedItems_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Projects/LastVisitedItems.vue"));
const MetricRankTag_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Metrics/MetricRankTag.vue"));
const BeCropMap_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/BeCropMap.vue"));
const EventTracker_1 = __importDefault(require("@becrop/abstract/Utils/EventTracker"));
let SideBySidePanel = class SideBySidePanel extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.eventTracker = new EventTracker_1.default();
        this.lastCategory = '';
    }
    eventTrackerListener(eventName, eventValues) {
        this.eventTracker.trackEvent(eventName, eventValues);
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get farmOptions() {
        return this.panel.availableFarms.map((f) => {
            let calcCrops = [];
            if (f.cropsInFields.length === 0) {
                calcCrops.push(f.area_crop);
            }
            else {
                calcCrops = [...f.cropsInFields];
            }
            return {
                label: (this.isITMember) ? `${f.area_name} - (${f.project_type.charAt(0).toUpperCase()})` : f.area_name,
                value: f.area_id,
                extLabel: f.acreage.shortLabel,
                crops: calcCrops,
                downloaded: f.downloaded
            };
        });
    }
    get defaultFarm() {
        return this.farmOptions.find((fo) => fo.value === this.panel.farm.meta.area_id);
    }
    get metricOptions() {
        return this.panel.availableMetrics.map((bm) => {
            let bigLabel = '';
            if ('category' in bm) {
                if (bm.category !== this.lastCategory) {
                    bigLabel = bm.category;
                    this.lastCategory = bm.category;
                }
                return {
                    bigLabel: (bigLabel.length > 0) ? bigLabel : '',
                    label: bm.name,
                    value: bm.code_name,
                    category: bm.category,
                    unit: 'BCS',
                    rank: bm.rank,
                    score: bm.score,
                    scale: bm.scale
                };
            }
            if ('visual' in bm) {
                const parsedCategory = (bm.visual.includes('general')) ? 'GRAL' : 'PHCH';
                if (parsedCategory !== this.lastCategory) {
                    bigLabel = parsedCategory;
                    this.lastCategory = parsedCategory;
                }
                return {
                    bigLabel: (bigLabel.length > 0) ? bigLabel : '',
                    label: bm.name,
                    value: bm.code_name,
                    unit: '',
                    category: '',
                    rank: bm.rank,
                    score: bm.score,
                    scale: ''
                };
            }
        });
    }
    get defaultMetric() {
        return this.metricOptions.find((mo) => mo.value === this.panel.metric.code_name);
    }
    updateFarmSelected(model) {
        let projectSelected = model;
        if ('value' in model) {
            projectSelected = this.panel.availableFarms.find((f) => f.area_id === model.value);
        }
        this.eventTrackerListener('farmSelectedComparativeMap', {
            farmId: projectSelected.area_id,
            farm: projectSelected.area_name,
            panel: this.id
        });
        this.$emit('updateProjectSelected', projectSelected);
    }
    updateMetricSelected(model) {
        const metricSelected = this.panel.availableMetrics.find((m) => m.code_name === model.value);
        this.eventTrackerListener('metricSelectedComparativeMap', {
            farmId: this.panel.farm.meta.area_id,
            farm: this.panel.farm.meta.name,
            metric: metricSelected.name,
            panel: this.id
        });
        this.updateMetric(metricSelected);
    }
    updateMetric(m) {
        this.$emit('updateMetric', m);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], SideBySidePanel.prototype, "panel", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], SideBySidePanel.prototype, "map_config", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], SideBySidePanel.prototype, "isITMember", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], SideBySidePanel.prototype, "id", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], SideBySidePanel.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], SideBySidePanel.prototype, "dimension", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], SideBySidePanel.prototype, "data", void 0);
SideBySidePanel = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Loader: bmk_ui_framework_1.Loader,
            Loading: bmk_ui_framework_1.Loading,
            SidebySideSelector: SidebySideSelector_vue_1.default,
            SidebySideLoader: SidebySideLoader_vue_1.default,
            FarmItem: FarmItem_vue_1.default,
            MetricSelectItem: MetricSelectItem_vue_1.default,
            LastVisitedItems: LastVisitedItems_vue_1.default,
            MetricRankTag: MetricRankTag_vue_1.default,
            SelectField: bmk_ui_framework_1.SelectField,
            Select: bmk_ui_framework_1.Select,
            BeCropMap: BeCropMap_vue_1.default
        },
    })
], SideBySidePanel);
exports.default = SideBySidePanel;
